import $console from "@zuto/utilities/src/$console"
import SubmissionService from "../services/submission-service"
import mapApplication, { Application } from "../Mappers/ApplicationFormMapper"
import getConfig from "next/config"
import { mapFormlessApp } from "../Mappers/FormlessAppMapper/mapping"
import { setCookie } from "nookies"
import { DAY } from "../constants"
import { FormlessAppMapProps, SetCloseSourceRedirectAndCookie, SubmissionResponse, SubmitFromlessApplicationProps } from "../types/Formless"
import axios from "axios"

const { publicRuntimeConfig } = getConfig()


export const mapFormlessApplication = ({
  prefillData,
  attribution,
  experimentName,
  metaData,
  quoteId,
  query
}: FormlessAppMapProps) => {
  const sanitisedPrefillData = mapFormlessApp(prefillData, attribution.source)
  const marketingPreferences = { email: false, sms: false, consentText: '' }
  return mapApplication(
    sanitisedPrefillData,
    attribution,
    experimentName,
    marketingPreferences,
    {
      ...metaData,
      isRetry: false
    },
    prefillData.vehicleDetails,
    quoteId,
    query
  ) as Application
}

export const getQueryParamValue = (
  param: string | string[] | undefined
): string | undefined => {
  if (typeof param === 'string') return param
  if (Array.isArray(param)) return param[0]
  return undefined
}

export const submitFromlessApplication = async ({
  application,
  eventsService,
  isRetry = false
}: SubmitFromlessApplicationProps): Promise<SubmissionResponse> => {
  try {
    const response = await SubmissionService(publicRuntimeConfig).submitApplication(application)
    void eventsService.sendAppFormSubmittedEvent(true, isRetry)
      .catch(err => $console.error('sendAppFormSubmittedEvent failed', err))
    return { ...response, success: true }
  } catch (err) {
    const isConflict = axios.isAxiosError(err) && err.response?.status === 409
    $console.error(isConflict ? 'Application already exists for this customer' : 'Failed to submit application', err)
    void eventsService.sendAppFormSubmittedEvent(false, isRetry)
      .catch(err => $console.error('sendAppFormSubmittedEvent failed', err))
    
    return isConflict ? { success: false, isConflict: true } : { success: false }
  }
}

export const setCloseSourceRedirectAndCookie = ({
  context,
  submissionResponse
}: SetCloseSourceRedirectAndCookie): SubmissionResponse  => {
  const { cookieDomain, closeRedirectUrl } = publicRuntimeConfig

  if (!submissionResponse.success && !submissionResponse.isConflict) {
    return submissionResponse
  }

  const authToken = submissionResponse.success ? submissionResponse.authToken : undefined

  authToken && setCookie(
    context,
    'authToken',
    authToken,
    {
      maxAge: DAY * 30,
      path: '/',
      domain: cookieDomain,
      httpOnly: true,
      // Local dev (`yarn dev`) serves the app over plain HTTP, and browsers silently drop
      // Set-Cookie headers marked Secure when they didn't arrive over TLS.
      secure: process.env.NODE_ENV !== 'development',
      sameSite: 'lax'
    }
  )
  
  return { success: true, redirectUrl: closeRedirectUrl, authToken, isConflict: submissionResponse.isConflict}
}

